import config from "react-global-configuration";

export const getConfiguration = (settingName) => {
  return config.get(settingName);
};
